import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import SpecialBulkCard from './add-special/SpecialBulkCard'
import '../../modules/reports/payment-video.css'
import './add-special/add-discount-bulk.css'
import {TutorialVideoLink} from '../../tenant/TutorialVideoLink'

const AddSpecialBulk = () => {
  const {formatMessage} = useIntl()
  const [showVideoHighlight, setShowVideoHighlight] = useState(false)

  useEffect(() => {
    const hasSeenVideo = document.cookie
      .split(';')
      .some((item) => item.trim().startsWith('special_bulk_video='))

    setShowVideoHighlight(!hasSeenVideo)
  }, [])

  return (
    <div className='adb-root'>
      <div className='adb-header'>
        <div>
          <h1 className='adb-title'>{formatMessage({id: 'add_discount_bulk'})}</h1>
          {/* Multi-supplier (B5): discounts attach to the supplier's own offer;
              per-row result statuses come back in the downloaded file. */}
          <div className='adb-note' role='note'>
            <i className='fas fa-circle-info' aria-hidden='true' />
            <span>{formatMessage({id: 'bulk_special_offer_note'})}</span>
          </div>
        </div>

        <TutorialVideoLink
          section='special_bulk'
          fallback='https://www.youtube.com/watch?v=_ZnZIGHF_LA'
          target='_blank'
          rel='noopener noreferrer'
          className={`adb-tutorial-btn ${showVideoHighlight ? 'video-highlight' : ''}`}
          onClick={() => {
            document.cookie = 'special_bulk_video=seen'
            setShowVideoHighlight(false)
          }}
        >
          <i className='fas fa-circle-play' aria-hidden='true' />
          {formatMessage({id: 'watch_tutorial'})}
        </TutorialVideoLink>
      </div>

      <SpecialBulkCard />
    </div>
  )
}

export default AddSpecialBulk
